// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Section3_mainWrapper__2sbzT","subWrapper":"Section3_subWrapper__PrQNR","coin":"Section3_coin__LA4IG","text1":"Section3_text1__MC0rz","text2":"Section3_text2__M52S0"};